import React, { useState, useEffect } from 'react';
import '../styles/ResponsiveTable.css';

const ResponsiveTable = ({ 
  data = [], 
  columns = [], 
  loading = false,
  onRowClick,
  mobileCardConfig = {},
  emptyMessage = "Aucune donnée disponible"
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  if (loading) {
    return (
      <div className="responsive-table-loading">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <span>Chargement...</span>
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="responsive-table-empty">
        <div className="empty-state">
          <p>{emptyMessage}</p>
        </div>
      </div>
    );
  }

  if (isMobile) {
    return (
      <div className="responsive-table-mobile">
        {data.map((row, index) => (
          <MobileCard 
            key={row.id || index}
            row={row}
            config={mobileCardConfig}
            onRowClick={onRowClick}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="responsive-table-container">
      <div className="table-responsive">
        <table className="responsive-table">
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th key={index} className={column.className || ''}>
                  {column.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr 
                key={row.id || index}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
                className={onRowClick ? 'clickable-row' : ''}
              >
                {columns.map((column, colIndex) => (
                  <td key={colIndex} className={column.className || ''}>
                    {column.render ? column.render(row) : row[column.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const MobileCard = ({ row, config, onRowClick }) => {
  const {
    title = (row) => row.nom || row.name || `Item ${row.id}`,
    subtitle = (row) => row.email || row.description || '',
    fields = [],
    actions = []
  } = config;

  return (
    <div 
      className={`mobile-card ${onRowClick ? 'mobile-card-clickable' : ''}`}
      onClick={onRowClick ? () => onRowClick(row) : undefined}
    >
      <div className="mobile-card-header">
        <div>
          <div className="mobile-card-title">{title(row)}</div>
          {subtitle(row) && (
            <div className="mobile-card-subtitle">{subtitle(row)}</div>
          )}
        </div>
      </div>
      
      {fields.length > 0 && (
        <div className="mobile-card-content">
          {fields.map((field, index) => (
            <div key={index} className="mobile-card-row">
              <span className="mobile-card-label">{field.label}</span>
              <span className="mobile-card-value">
                {field.render ? field.render(row) : row[field.key]}
              </span>
            </div>
          ))}
        </div>
      )}
      
      {actions.length > 0 && (
        <div className="mobile-card-actions">
          {actions.map((action, index) => (
            <button
              key={index}
              className={`btn btn-sm ${action.className || 'btn-primary'}`}
              onClick={(e) => {
                e.stopPropagation();
                action.onClick(row);
              }}
            >
              {action.icon && action.icon}
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ResponsiveTable;